import BannerHeader from "../../../Components/BannerHeader/BannerHeader";
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav";
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo";
import classes from "./PDFPrinting.module.css";

import Timeline from "../Components/Timeline/Timeline";
import Gallery from "../../Body/Gallery/Gallery";
import CustomerReview from "../../Body/CustomerReview/CutomerReview";
import { ContactUs } from "../Components/ContactUs/ContactUs";
import Footer from "../../Footer/Footer";
import FAQ from "../FAQ/FAQ";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllFaq } from "../../../Store/actions/FaqAction";
import { urls } from "../../../Routes/Urls";
import useScrollToTop from "../../../Hooks/useScrollToTop";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useScreenSize from "../../../Hooks/UseScreenSize";
import SEO from "../../../Components/SEO";

const step1 = "/Assets/Images/PDF/Quick-PDF-Submission.png";
const step2 = "/Assets/Images/PDF/Expert-Binding-Insights.png";
const step3 = "/Assets/Images/PDF/Personalized-Customization-Creation.png";
const step4 = "/Assets/Images/PDF/Fair-Pricing.png";
const step5 = "/Assets/Images/PDF/Your-Exquisite-Leather-Bound-Treasue.png";


const bgImage = "Assets/Images/ServicePages/PdfPrinting.png"

const PDFPrinting = () => {
  const history = useHistory();
  const steps = [
    {
      number: "01",
      title: "Quick PDF Submission",
      description:
        "Starting with the basic step of submitting the PDF. We’ve made it very easy for you and can be done in a jiffy, all you have to do is submit the pdf that you want to get transformed at info@rarebiblio.com or you can start by submitting a user-friendly form below that is going to make your word hassle-free.",
      image: step1, 
      align: "left",
      alt:"Print a book from your PDF—turn digital files into beautiful, professionally bound books for personal or gifting use."
    },
    {
      number: "02",
      title: "Expert Binding Insights",
      description:
        "Our skilled craftsmen make sure they get into every detail of the PDFs that are submitted. \n \n Through their expert analysis and insights an optimal binding size and style is decided that will be in sync with your written digital document.",
      image: step2, 
      align: "right",
      alt:"Easily print a book from PDF with custom covers and bindings—ideal for portfolios, manuscripts, or treasured memories."
    },
    {
      number: "03",
      title: "Personalize Your Book",
      description:
        "Rare Biblio understands that your document is an emotion for you and therefore we make sure to bring this feature of personalized customization for you. You get a chance to select from leather type to vibrant leather colors, custom border and logo embossing, golden-edged pages i.e. gilding, and many more that will make your book a luxurious masterpiece that you wouldn’t have even imagined.Don’t worry, to make you understand this process better our team of experts will walk you through it and guide you in every possible way to help you bring your vision to life.",
        descriptionMobile:"Rare Biblio understands that your document is an emotion for you and we give you a chance to select from leather type to vibrant leather colors, custom border and logo embossing, etc. that will make your book a luxurious masterpiece that you wouldn’t have even imagined.",
      image: step3, 
      CTA:"Check out :",
      CTAButton: "How to start with customization",
      onClick:() => history.push(urls.SERVICES),
      align: "left",
      alt:"Fully customizable book design—select every detail from leather finish to logo embossing with expert guidance."
    },
    {
      number: "04",
      title: "Fair Pricing",
      description:
        "We do not intend to exploit our customers in any way, therefore, we maintain pure transparency and provide you with a fair pricing quote. You're going to know exactly how much it will cost to turn your PDF into a lavish, leather-bound book",
      image: step4, 
      align: "right",
      alt:"Luxury printing meets honesty—convert your PDF to a stunning custom book at a fair price."
    },
    {
      number: "05",
      title: "Your Exquisite Leather-Bound Treasure",
      description:
        "Now, comes the final step that you must have been waiting for, this is when your digital document starts getting its shape, and the leathery aesthetics are being applied to it.Our expert craftsmen begin to work on your book and very precisely they give a new life to your document by using the finest of the finest materials, adding perfectly hand-stitched binding to carefully selected leather covers, everything is flawlessly assembled.So, are you ready to turn your digital documents into timeless leather-bound treasures? Fill out the form below to start your journey with Rare Biblio. Learn about the grace and toughness of finely bound books that will be treasured for many years. ",
      descriptionMobile:"Our expert craftsmen begin to work on your book and very precisely they give a new life to your document by using the finest of the finest materials, adding perfectly hand-stitched binding to carefully selected leather covers, everything is flawlessly assembled.",
      image: step5, 
      align: "left",
      alt:"From PDF to luxurious leather book—crafted by experts using the finest hand-selected leather."
    },
  ];
  const crumbs = [
    { title: "Home", path: "/" },
    { title: "PDF Printing", path: urls.PDFPRINTING },
  ];

  const video = useSelector(
    (state) => state.serviceVideo?.videos?.pdfPrintingVideo
  );
  const allFaq = useSelector((state) => state.Faq.questions);

  const dispatch = useDispatch();

  useEffect(() => {
    getAllFaq("category", "PDF Transformation", "", dispatch);
  }, []);

  const scrollRef = useScrollToTop();

  return (
    <>
     <SEO
        keywords="Print a book from pdf"
        title="PDF to Leather-Bound Book - Make & Print Book From PDF"
        description="Transform your PDF into a beautiful leather-bound book with Rare Biblio. Bring your digital pages to life in a stunning, tangible form. Create your book today!"
        canonicalUrl="https://rarebiblio.com/print-books-from-pdf" 
        structuredData={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Service",
              "serviceType": "Print Books from PDF",
              "name": "Print Your Book from PDF | Rare Biblio",
              "description": "Easily turn your PDF into a professionally printed book. Rare Biblio offers premium quality binding, customization, and doorstep delivery.",
              "provider": {
                "@type": "Organization",
                "name": "Rare Biblio",
                "url": "https://www.rarebiblio.com/",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
                },
                "sameAs": [
                  "https://www.facebook.com/rarebiblio/",
                  "https://www.instagram.com/Rarebiblio/",
                  "https://www.linkedin.com/company/Rarebiblio",
                  "https://in.pinterest.com/rare_biblio/",
                  "https://x.com/Rarebiblio"
                ]
              },
              "url": "https://www.rarebiblio.com/print-books-from-pdf"
            },
            {
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "Can I customize the cover design of my leather-bound book?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! We offer a range of customization options for the cover of your leather-bound book. You can choose from various leather colors, textures, and finishes, and you can add personalized engravings, logos, or designs to make the book truly unique."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Will my PDF document be printed exactly as I sent it?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We will print your PDF document exactly as it’s sent to us, preserving all formatting, fonts, and images. However, if you want to make any last-minute adjustments or have special requirements for the print layout (such as specific margins or text placement), feel free to let us know before we begin the printing process."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What types of files can I submit for transformation?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We primarily accept PDF files, but we also work with DOCX and EPUB formats. If your file needs formatting or conversion, our team can assist you with that too."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How durable are these handcrafted leather books?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our books are crafted using premium materials, including archival-grade paper and genuine leather covers, making them highly durable and built to last for generations. Each one is carefully bound by skilled artisans."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I get a customized edition with my name, logo, or special message on the cover?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! We offer full customization options, including custom name embossing, logo foiling, and personalized cover titles. You can even choose to include dedication pages or custom chapter dividers."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What are the type of paper you provide for the printing purpose?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We offer various high-quality paper options, including matte, glossy, silk/satin, cream, and recycled paper. Each is suited for different book types and styles. For expert advice on the best option for your project, feel free to contact us at info@rarebiblio.com."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Which is the standard paper that is used for printing?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The standard paper we use for printing is 80 GSM acid-free natural shade paper. It’s a premium quality paper that ensures durability and excellent print results, making it ideal for a variety of printing needs."
                  }
                }
              ]
            }
          ]
        }}
      />

    <div ref={scrollRef}>
      <PrimaryNav />

      <BannerHeader
        bgImage={bgImage}
        crumbs={crumbs}
        title={"Let’s Print A Book From PDF"}
        desc={
          "Redefine documents, redefine efficiency."
        }
      />

      <div className={classes.mainContainer}>
        <ServiceVideo
          videoSrc={video}
          title={"PDF Transformation"}
          desc={
            "Your digital creations must have taken days, weeks, or even years to complete; now it's time to feel them in your hands as an exquisite leather-bound masterpiece, wrapped in vibrant colors of leather of your choice and shimmery golden-gilded pages adding royal finish to your book."
          }
        />
      </div>

      {/* <WhyUs /> */}

      <div className={classes.printingSteps}>
        <Timeline steps={steps} />
      </div>

      <div className={classes.contactUs}>
        <ContactUs
          category={"pdfPrinting"}
          title={"Start Your PDF-to-Book Transformation Process"}
          desc={
            "Get in touch with us right now to see the superior craftsmanship that makes us stand out!"
          }
        />
      </div>


      <Gallery />

      <CustomerReview />

      <FAQ data={allFaq} />

      
      <Footer />
    </div>
    </>
  );
};

export default PDFPrinting;
